import { render, staticRenderFns } from "./ClientMailbuilderParameters.vue?vue&type=template&id=43eb68b4"
import script from "./ClientMailbuilderParameters.vue?vue&type=script&lang=js"
export * from "./ClientMailbuilderParameters.vue?vue&type=script&lang=js"
import style0 from "./ClientMailbuilderParameters.vue?vue&type=style&index=0&id=43eb68b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports